import {
  BookAppointmentSuccessActionPayload,
  FetchAppointmentsSuccessActionPayload,
  UpdateAppointmentSuccessActionPayload,
} from 'modules/appointments/actions';
import { convertSnakeToCamelCase } from 'utils/convertSnakeToCamelCase';
import { normalizeAppointment } from 'modules/appointments/utils/normalizeAppointment';

/*
{
    "appointment": {
        "id": 22735,
        "cl_id": null,
        "app_date": "2020-05-03",
        "app_time": "2000-01-01T15:30:00.000Z",
        "service": "Cash Treatment",
        "therapist_id": 1,
        "patient_id": 1816,
        "duration": 60,
        "status": "Pending",
        "status_name": "Cash Treatment Scheduled",
        "app_type": "Cash Treatment",
        "case_id": 2199,
        "billing_batch_num": null,
        "patient_responsibility": null,
        "amount_paid": null,
        "allowed_amount": null,
        "cxlns_reason": null,
        "notes": null
    }
}
 */

export const bookAppointmentCallTranslator = (
  response: any,
): BookAppointmentSuccessActionPayload => {
  const convertedResponse = convertSnakeToCamelCase(response);

  // Handle new format with appointments array
  if (
    convertedResponse.appointments &&
    Array.isArray(convertedResponse.appointments)
  ) {
    return {
      appointmentsCreated:
        convertedResponse.appointmentsCreated ||
        convertedResponse.appointments_created,
      totalRequested:
        convertedResponse.totalRequested || convertedResponse.total_requested,
      appointments: convertedResponse.appointments.map((appointment: any) =>
        normalizeAppointment(appointment),
      ),
      errors: convertedResponse.errors || [],
      recurrenceInfo:
        convertedResponse.recurrenceInfo || convertedResponse.recurrence_info,
    };
  }

  // Fallback for old format (single appointment)
  return convertedResponse;
};

export const updateAppointmentCallTranslator = (
  appointment: object,
): UpdateAppointmentSuccessActionPayload => {
  return normalizeAppointment(convertSnakeToCamelCase(appointment));
};

export const fetchAppointmentCallTranslator = (
  response: object[],
): FetchAppointmentsSuccessActionPayload =>
  response.map(appointment =>
    normalizeAppointment(convertSnakeToCamelCase(appointment)),
  );
